export const WEBHOOK_EVENTS = [
    'template.published',
    'document.generated',
    'envelope.sent',
    'envelope.viewed',
    'signer.completed',
    'envelope.completed',
    'envelope.declined',
    'envelope.cancelled',
    'envelope.expired',
    // Fresh signing links were issued (dashboard "Reissue links" or POST /remind).
    // Carries the new signingUrl per outstanding signer — the API response is the
    // other copy, and there is no third: tokens are stored hashed.
    'envelope.reminder',
    // Failure events. Everything above reports something going right; without
    // these, a run that dies before its success event is indistinguishable from
    // one still in progress, and the automation layer never finds out.
    'envelope.finalize_failed',
    'document.generation_failed',
];
export const API_SCOPES = [
    'templates:read',
    'templates:write',
    'documents:read',
    'documents:write',
    'webhooks:manage',
];
//# sourceMappingURL=events.js.map